module.exports = __webpack_public_path__ + "static/controlBG-a31aa7d27b4b6a0eb11ec79f0feb9ac3.png";